import { css } from '@emotion/core';

export const colorsCss = css`
  :root {
    --color-neutral-85: #252525;
    --color-neutral-70: #b2b2b2;
    --color-neutral-15: #d9d9d9;
    --color-neutral-5: #f2f2f2;
    --color-neutral-0: #ffffff;

    --color-plum: #670d2d;
    --color-plum-70: #95566c;
    --color-plum-50: #b38696;
    --color-plum-30: #d1b6c0;

    --color-dusty-pink: #fce4de;
    --color-dusty-pink-70: #fdece8;
    --color-dusty-pink-50: #fef1ef;
    --color-dusty-pink-30: #fef7f5;

    --color-smoke: #2d3540;
    --color-smoke-70: #6c7279;
    --color-smoke-50: #969a9f;
    --color-smoke-30: #c0c2c6;

    --color-tangerine: #f4534a;
    --color-tangerine-70: #f78780;
    --color-tangerine-50: #f9a9a4;
    --color-tangerine-30: #fccbc9;

    --color-putty: #f4f0ef;
    --color-putty-70: #f4f0ef;
    --color-putty-50: #f9f7f7;
    --color-putty-30: #fcfafa;

    // State colors only
    --color-green: #007b88;
    --color-green-70: #4ca3ac;
    --color-green-50: #80bdc4;
    --color-green-30: #b2d7db;

    --color-honey: #cb7813;
    --color-honey-70: #dba05a;
    --color-honey-50: #e5bb89;
    --color-honey-30: #efd6b8;

    --color-coral: #fa5245;
    --color-coral-70: #fc867d;
    --color-coral-50: #fda8a2;
    --color-coral-30: #fecbc7;
  }
`;
